"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgValidate(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm7.0549 10.9969 4.8309-4.6835-1.3578-1.3163-3.468 3.3622-1.5883-1.5393-1.3578 1.3159zm.9451-9.29034 1.44564.90156 1.701-.0587.79911 1.5052 1.5049.79893-.05881 1.70076.9016 1.44569-.90156 1.44564.0587 1.701-1.5052.79911-.79893 1.5049-1.70076-.05881-1.44569.9016-1.44564-.90156-1.701.0587-.79911-1.5052-1.5049-.79893.05881-1.70076-.9016-1.44569.90156-1.44564-.0587-1.701 1.5052-.79911.79893-1.5049 1.70076.05881zm0-1.65747-1.82587 1.1387-2.15056-.07435-1.00906 1.90071-1.901 1.00922.07423 2.15077-1.13865 1.82586 1.1387 1.82587-.07435 2.15056 1.90071 1.00906 1.00922 1.901 2.15077-.07423 1.82586 1.13865 1.82587-1.1387 2.15056.07435 1.00906-1.90071 1.901-1.00922-.07423-2.15077 1.13865-1.82586-1.1387-1.82587.07435-2.15056-1.90071-1.00906-1.00922-1.901-2.15077.07423z' })));
}
exports.default = SvgValidate;
